import './LoaderFull.css';

/**
 * Full-screen loader component
 */
export default function LoaderFull() {
  return (
    <div className="loader-full" role="status" aria-label="Loading">
      <div className="loader-full-spinner"></div>
    </div>
  );
}